import {Component} from 'react';
import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';
import {connect} from 'react-redux';
import * as Sentry from '@sentry/browser';
import injectSheet from 'react-jss';
import {Icon} from 'front-onceforall-core';
import config from '../../config';
import styles from './ErrorBoundary.style';
import ErrorPageIcon from './ErrorPageIcon';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {error: null};
  }

  componentDidCatch(error, errorInfo) {
    this.setState({error});
    if (config.sentry) {
      const {user} = this.props;
      console.error('User: ', user);
      console.error('Organisation: ', this.props.organisation);
      Object.assign(errorInfo, {organisation: this.props.organisation});
      Sentry.withScope(scope => {
        if (user) {
          scope.setUser({
            id: user.id,
            email: user.email,
            username: user.fullName
          });
        }

        Object.keys(errorInfo).forEach(key => {
          scope.setExtra(key, errorInfo[key]);
        });
        Sentry.captureException(error);
      });
    }
  }

  handleBackToDashboard() {
    window.location.href = window.location.origin;
  }

  render() {
    const {classes} = this.props;
    if (this.state.error) {
      return (
        <div className={classes.wrapper}>
          <div className={classes.errorIcon}><ErrorPageIcon/></div>
          <div className={classes.title}><Translate value="errorPage.title"/></div>
          <div className={classes.container}>
            <strong><Translate value="errorPage.subtitle"/></strong>
            <Translate value="errorPage.text"/>
            <a href={`mailto:${I18n.t('errorPage.contactEmail')}`}>{I18n.t('errorPage.contactEmail')}</a>
            <button
              type="button"
              className="large primary inline-container mt-4"
              onClick={this.handleBackToDashboard}
            >
              <Icon icon="refresh"/>
              <Translate value="errorPage.buttonLabel"/>
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  organisation: PropTypes.object,
  user: PropTypes.object
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation,
    user: state.user
  };
}

export default connect(mapStateToProps, null)(injectSheet(styles)(ErrorBoundary));
